import { inspectionsService } from '@/services/inspections';
import type { GetInspectionsSummaryParams } from '@/services/inspections/types';
import { STALE_TIME_THIRTY_SECONDS_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export function useInspectionsSummary(
  params: GetInspectionsSummaryParams = {}
) {
  return useQuery({
    queryKey: ['inspections-summary', params],
    queryFn: async () => {
      const response = await inspectionsService.getInspectionsSummary(params);

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar resumo de inspeções'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_THIRTY_SECONDS_MS,
  });
}
